import React from 'react';
export function Stats() {
  return <div className="grid grid-cols-1 md:grid-cols-3 border-y border-dark-border relative z-10 bg-dark/50 backdrop-blur-sm" data-id="element-138">
      <div className="p-9 text-center border-b md:border-b-0 md:border-r border-dark-border" data-id="element-139">
        <div className="font-bebas text-5xl text-gradient-pink-purple" data-id="element-140">
          500+
        </div>
        <div className="text-[0.75rem] text-text-muted tracking-[2px] uppercase mt-1" data-id="element-141">
          Cuadros Entregados
        </div>
      </div>
      <div className="p-9 text-center border-b md:border-b-0 md:border-r border-dark-border" data-id="element-142">
        <div className="font-bebas text-5xl text-gradient-pink-purple" data-id="element-143">23</div>
        <div className="text-[0.75rem] text-text-muted tracking-[2px] uppercase mt-1" data-id="element-144">
          Provincias Alcanzadas
        </div>
      </div>
      <div className="p-9 text-center" data-id="element-145">
        <div className="font-bebas text-5xl text-gradient-pink-purple" data-id="element-146">
          100%
        </div>
        <div className="text-[0.75rem] text-text-muted tracking-[2px] uppercase mt-1" data-id="element-147">
          Diseño Personalizado
        </div>
      </div>
    </div>;
}